import { useTranslation } from 'contexts/Localization'
import checkStakeNft from 'hooks/setCheckStakeNft'
import getListNftBuy from 'hooks/setGetListNftBuy'
import Link from 'next/link'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setOpvPrice } from 'state/wallet/actions'
import getWalletSummary from 'state/wallet/fetch/getWalletSummary'
import styled from 'styled-components'
import { ArrowBackIcon, Box } from 'widgets'
import BalanceOverview from './components/BalanceOverview'
import WalletTabs from './components/WalletTabs'

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  margin-top: 88px;
  padding: 48px 16px;
  position: relative;

  .arrow-icon {
    transform: rotate(180deg);
    width: 20px;
  }
`

const Content = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 1032px;
  margin: 0 auto;
`

const WalletPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    getListNftBuy((list) => {
      if (list && list?.length > 0) {
        checkStakeNft(list[list?.length - 1]?.id, (res) => {
          if (res?.opvPrice) {
            dispatch(setOpvPrice(+res?.opvPrice))
          }
        })
      }
    })
  }, [dispatch])

  return (
    <Wrapper>
      <Content>
        <div className="flex md:flex-row flex-col md:items-center gap-4 justify-between mb-6">
          <h1 className="font-bold md:text-[27px] text-[22px] leading-[1.5] text-primary">
            {t('Wallet overview')}
          </h1>

          <Link href="/history" passHref>
            <Box className="flex items-center space-x-2 cursor-pointer">
              <p className="text-link text-[14px] leading-6 font-bold">{t('Activities history')}</p>
              <ArrowBackIcon className="arrow-icon" pathClassName="fill-brand-500 dark:full-brand-400" />
            </Box>
          </Link>
        </div>

        <BalanceOverview />
        <WalletTabs />
      </Content>
    </Wrapper>
  )
}

export default WalletPage
